import { render } from "./GetAccessTokenModal.vue?vue&type=template&id=25dbe375"
import script from "./GetAccessTokenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GetAccessTokenModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/GetAccessTokenModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25dbe375"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25dbe375', __exports__)) {
    api.reload('25dbe375', __exports__)
  }
  
  module.hot.accept("./GetAccessTokenModal.vue?vue&type=template&id=25dbe375", () => {
    api.rerender('25dbe375', render)
  })

}


export default __exports__